import {
    InstanceFactory,
    KendraConst,
} from "@amzn/ask-legal-domain";
import { QueryResultItem } from "@aws-sdk/client-kendra";

export const getInstanceIdFromResult = (resultItem: QueryResultItem): string | null => {
    const instanceIdAttribute = resultItem.DocumentAttributes?.find(attr =>
        attr.Key === KendraConst.ContainerIngestionKendraAttributes.Default.InstanceId
    );
    if (instanceIdAttribute?.Value?.StringValue) {
        return instanceIdAttribute.Value.StringValue;
    }

    const pageIdAttribute = resultItem.DocumentAttributes?.find(attr =>
        attr.Key === KendraConst.ContainerIngestionKendraAttributes.Custom.PageId
    );
    if (pageIdAttribute?.Value?.StringValue) {
        return InstanceFactory.fromEntityId(pageIdAttribute.Value.StringValue);
    }

    return null;
};
